<template>
    <div class="l-element">
        <canvas :id="`canvas_${previewId}`" class="c-jhs-free-preview-certificate-canvas"></canvas>
    </div>
</template>

<script>

export default {
    name: "JhsFreePreviewCertificate",
    props: {
        /**
         * 識別id
         */
        previewId: {
            type: String,
            required: true
        },
        /**
         * 本人確認書類の種類
         * JhsFreeStore.js
         */
        certificateFile: {
            type: File,
            required: true
        }
    },
    emits: ['input'],
    data() {
        return {
            ctx: null,
        }
    },
    mounted() {
        this.renderFile()
    },
    beforeUnmount() {
        this.deleteCanvas()
    },
    methods: {
        renderFile() {
            const reader = new FileReader();
            const self = this

            reader.onload = function (e) {
                const dataURL = e.target.result
                const c = document.getElementById(`canvas_${self.previewId}`);
                self.ctx = c.getContext('2d')
                const img = new Image();

                img.onload = function () {
                    c.width = img.width;
                    c.height = img.height;
                    self.ctx.drawImage(img, 0, 0);

                    // 変換処理
                    // canvasの画像をjpegに変換する
                    const base64 = c.toDataURL('image/jpeg', 0.4);
                    const bin = atob(base64.replace(/^.*,/, ''));
                    const buffer = new Uint8Array(bin.length);
                    for (let i = 0; i < bin.length; i++) {
                        buffer[i] = bin.charCodeAt(i);
                    }
                    // fileオブジェクトにjpegで変換
                    const file = new File([buffer.buffer], "sample.jpeg",{
                        type: "image/jpeg"
                    });
                    // 親に渡す
                    self.$emit("input", file)
                };

                img.src = dataURL;
            };
            reader.readAsDataURL(this.certificateFile);
        },
        deleteCanvas() {
            const c = document.getElementById(`canvas_${this.previewId}`);
            if(c){
                c.width = 0;
                c.height = 0;
            }
            if(this.ctx){
                delete this.ctx
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.c-jhs-free-preview-certificate {
    &-canvas {
        width: 100%
    }
}
</style>
